import React from "react";
import { CartProvider } from "react-use-cart";
import Login from "./Login/Login"; 
import AllHome from "./Home/AllHome";

function App() {
  return (
    <CartProvider>
      <AllHome /> 
    </CartProvider>
  );
}

export default App;

